/**
 * @generated SignedSource<<0f0a6e50ba9a9d41399b7482259e44c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PrimaryNavigationRight_viewer$data = {
  readonly id: string;
  readonly sisenseUserId: string | null;
  readonly backendId: number | null;
  readonly unseenNotifications: number | null;
  readonly projectOwner: boolean | null;
  readonly company: {
    readonly id: string;
    readonly useTimeApproval: boolean | null;
    readonly useTimeOffApproval: boolean | null;
    readonly unit4Enabled: boolean | null;
    readonly isUsingProjectAllocation: boolean | null;
    readonly tier: TierType | null;
    readonly apiKeys: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly key: string | null;
          readonly active: boolean | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationMenu_viewer">;
  readonly " $fragmentType": "PrimaryNavigationRight_viewer";
};
export type PrimaryNavigationRight_viewer$key = {
  readonly " $data"?: PrimaryNavigationRight_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PrimaryNavigationRight_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PrimaryNavigationRight_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sisenseUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unseenNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeOffApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit4Enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingProjectAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            }
          ],
          "concreteType": "ApiKeyConnection",
          "kind": "LinkedField",
          "name": "apiKeys",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ApiKeyEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ApiKey",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "active",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "apiKeys(first:10)"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationMenu_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "2815f95fa61b565b2125687962185bd9";

export default node;
